import saveAs from 'file-saver'

import { post, get } from '@/util/auth'

import { API_ROUTE_DOCUMENTS, API_ROUTE_DOCUMENT } from './api-routes'

export const commonDocumentResources = {
  authorizeFileDownload: async (documentId: number) => {
    const response = await get<{ body: string; filename: string }>(
      API_ROUTE_DOCUMENT.replace(':id', String(documentId))
    )
    saveAs(atob(response.body), response.filename)

    return { filename: response.filename }
  },

  // Mutations
  uploadAuthorization: async ({ file, type }: { file: File; type: string }) => {
    const base64EncodedFile = await getBase64(file)
    const parsedFile = transformFileForWS({ file, base64EncodedFile, type })

    const response = await post<{ id: number; filename: string }>(API_ROUTE_DOCUMENTS, parsedFile)

    return response
  },
}

const getBase64 = (file: File) =>
  new Promise<string | ArrayBuffer>((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => {
      if (reader.result) resolve(reader.result)
    }
    reader.onerror = error => reject(error)
  })

const transformFileForWS = ({
  file,
  base64EncodedFile,
  type,
}: {
  file: File
  base64EncodedFile: string | ArrayBuffer
  type: string
}) => ({
  type,
  filename: file.name,
  extension: file.name.split('.').pop()?.toUpperCase(),
  body: base64EncodedFile,
})
